import React from 'react';

const Navbar = () => {
  return (
      <nav className="bg-primary text-white p-4 flex justify-between items-center">
      <div className="text-2xl font-bold">Tiranga Express</div>
      <div className="space-x-4">
        <a href="/" className="hover:text-secondary">Home</a>
         <a href="/about-us" className="hover:text-secondary">About Us</a>
        <a href="/services" className="hover:text-secondary">Services</a>
        <a href="/partners" className="hover:text-secondary">Partners</a>
        <a href="/login" className="hover:text-secondary">Login</a>
      </div>
    </nav>
  );
};

export default Navbar;